<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                :pages="[
                    {
                        name: $tc('messages.programmings', 2),
                        href: meta.links.index,
                    },
                    {
                        name: $t('messages.calendar'),
                        href: null,
                    },
                    {
                        name: $t('messages.week'),
                        href: null,
                    },
                ]"
            />
        </template>

        <header
            class="sticky top-0 z-10 sm:grid items-center justify-between shrink-0 grid-cols-2 px-4 bg-white border-b md:grid-cols-3"
        >
            <aside class="hidden justify-self-start lg:block">
                <div class="flex items-center -ml-2 space-x-2">
                    <inertia-link
                        :href="calendar.previousMonthLink"
                        class="flex items-center justify-center w-10 h-10 text-indigo-500 transition rounded-full hover:bg-gray-500/5 focus:bg-indigo-500/10 focus:outline-none"
                    >
                        <svg class="w-7 h-7" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <path
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.5"
                                d="M13.25 8.75L9.75 12L13.25 15.25"
                            ></path>
                        </svg>
                    </inertia-link>

                    <p class="text-xl">
                        <span class="font-semibold tracking-tight mr-1">
                            {{ calendar.monthName }}
                        </span>
                        <span class="tracking-tight mr-1 text-sm"> ( {{ calendar.dates_range_display }} ) </span>
                    </p>

                    <inertia-link
                        :href="calendar.nextMonthLink"
                        class="flex items-center justify-center w-10 h-10 text-indigo-500 transition rounded-full hover:bg-gray-500/5 focus:bg-indigo-500/10 focus:outline-none"
                    >
                        <svg class="w-7 h-7" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <path
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.5"
                                d="M10.75 8.75L14.25 12L10.75 15.25"
                            ></path>
                        </svg>
                    </inertia-link>
                </div>
            </aside>

            <aside class="flex items-center lg:hidden">
                <inertia-link
                    :href="calendar.previousMonthLink"
                    class="flex items-center justify-center w-10 h-10 text-indigo-500 transition rounded-full hover:bg-gray-500/5 focus:bg-indigo-500/10 focus:outline-none"
                >
                    <svg class="w-7 h-7" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <path
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.5"
                            d="M13.25 8.75L9.75 12L13.25 15.25"
                        ></path>
                    </svg>
                </inertia-link>
                <span class="font-semibold tracking-tight mr-1">
                    {{ calendar.monthName }}
                </span>
                <span class="tracking-tight mr-1 text-sm"> ( {{ calendar.dates_range_display }} ) </span>
                <inertia-link
                    :href="calendar.nextMonthLink"
                    class="flex items-center justify-center w-10 h-10 text-indigo-500 transition rounded-full hover:bg-gray-500/5 focus:bg-indigo-500/10 focus:outline-none"
                >
                    <svg class="w-7 h-7" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <path
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.5"
                            d="M10.75 8.75L14.25 12L10.75 15.25"
                        ></path>
                    </svg>
                </inertia-link>
            </aside>

            <aside class="justify-self-center md:block">
                <nav
                    class="inline-flex items-center justify-center p-1 space-x-1 overflow-hidden text-sm text-gray-600 bg-gray-100 rounded-xl"
                >
                    <button
                        class="hidden h-8 px-5 font-medium transition rounded-lg hover:text-gray-800 focus:text-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-inset"
                    >
                        {{ $t('messages.day') }}
                    </button>

                    <button
                        class="h-8 px-5 font-medium text-indigo-600 transition bg-white rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-inset"
                    >
                        {{ $t('messages.week') }}
                    </button>

                    <inertia-link
                        :href="meta.links.calendar_month_index"
                        class="inline-flex items-center h-8 px-5 font-medium transition rounded-lg hover:text-gray-800 focus:text-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-inset"
                    >
                        {{ $t('messages.month') }}
                    </inertia-link>
                </nav>
            </aside>

            <aside class="justify-self-end" v-if="false">
                <ul class="flex items-center -mr-2 space-x-1">
                    <li>
                        <a
                            class="flex items-center justify-center w-10 h-10 text-indigo-500 transition rounded-full hover:bg-gray-500/5 focus:bg-indigo-500/10 focus:outline-none"
                            href="#"
                        >
                            <svg class="w-7 h-7" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <path
                                    stroke="currentColor"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="1.5"
                                    d="M4.75 19.25L9 18.25L18.2929 8.95711C18.6834 8.56658 18.6834 7.93342 18.2929 7.54289L16.4571 5.70711C16.0666 5.31658 15.4334 5.31658 15.0429 5.70711L5.75 15L4.75 19.25Z"
                                ></path>
                                <path
                                    stroke="currentColor"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="1.5"
                                    d="M19.25 19.25H13.75"
                                ></path>
                            </svg>
                        </a>
                    </li>

                    <li>
                        <a
                            class="flex items-center justify-center w-10 h-10 text-indigo-500 transition rounded-full hover:bg-gray-500/5 focus:bg-indigo-500/10 focus:outline-none"
                            href="#"
                        >
                            <svg class="w-7 h-7" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle
                                    cx="11"
                                    cy="11"
                                    r="6.25"
                                    stroke="currentColor"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="1.5"
                                ></circle>
                                <path
                                    fill="currentColor"
                                    d="M18.7197 19.7803C19.0126 20.0732 19.4874 20.0732 19.7803 19.7803C20.0732 19.4874 20.0732 19.0126 19.7803 18.7197L18.7197 19.7803ZM14.9697 16.0303L18.7197 19.7803L19.7803 18.7197L16.0303 14.9697L14.9697 16.0303Z"
                                ></path>
                            </svg>
                        </a>
                    </li>

                    <li>
                        <a
                            class="flex items-center justify-center w-10 h-10 text-indigo-500 transition rounded-full hover:bg-gray-500/5 focus:bg-indigo-500/10 focus:outline-none"
                            href="#"
                        >
                            <svg class="w-7 h-7" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <path
                                    stroke="currentColor"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="1.5"
                                    d="M13.1191 5.61336C13.0508 5.11856 12.6279 4.75 12.1285 4.75H11.8715C11.3721 4.75 10.9492 5.11856 10.8809 5.61336L10.7938 6.24511C10.7382 6.64815 10.4403 6.96897 10.0622 7.11922C10.006 7.14156 9.95021 7.16484 9.89497 7.18905C9.52217 7.3524 9.08438 7.3384 8.75876 7.09419L8.45119 6.86351C8.05307 6.56492 7.49597 6.60451 7.14408 6.9564L6.95641 7.14408C6.60452 7.49597 6.56492 8.05306 6.86351 8.45118L7.09419 8.75876C7.33841 9.08437 7.3524 9.52216 7.18905 9.89497C7.16484 9.95021 7.14156 10.006 7.11922 10.0622C6.96897 10.4403 6.64815 10.7382 6.24511 10.7938L5.61336 10.8809C5.11856 10.9492 4.75 11.372 4.75 11.8715V12.1285C4.75 12.6279 5.11856 13.0508 5.61336 13.1191L6.24511 13.2062C6.64815 13.2618 6.96897 13.5597 7.11922 13.9378C7.14156 13.994 7.16484 14.0498 7.18905 14.105C7.3524 14.4778 7.3384 14.9156 7.09419 15.2412L6.86351 15.5488C6.56492 15.9469 6.60451 16.504 6.9564 16.8559L7.14408 17.0436C7.49597 17.3955 8.05306 17.4351 8.45118 17.1365L8.75876 16.9058C9.08437 16.6616 9.52216 16.6476 9.89496 16.811C9.95021 16.8352 10.006 16.8584 10.0622 16.8808C10.4403 17.031 10.7382 17.3519 10.7938 17.7549L10.8809 18.3866C10.9492 18.8814 11.3721 19.25 11.8715 19.25H12.1285C12.6279 19.25 13.0508 18.8814 13.1191 18.3866L13.2062 17.7549C13.2618 17.3519 13.5597 17.031 13.9378 16.8808C13.994 16.8584 14.0498 16.8352 14.105 16.8109C14.4778 16.6476 14.9156 16.6616 15.2412 16.9058L15.5488 17.1365C15.9469 17.4351 16.504 17.3955 16.8559 17.0436L17.0436 16.8559C17.3955 16.504 17.4351 15.9469 17.1365 15.5488L16.9058 15.2412C16.6616 14.9156 16.6476 14.4778 16.811 14.105C16.8352 14.0498 16.8584 13.994 16.8808 13.9378C17.031 13.5597 17.3519 13.2618 17.7549 13.2062L18.3866 13.1191C18.8814 13.0508 19.25 12.6279 19.25 12.1285V11.8715C19.25 11.3721 18.8814 10.9492 18.3866 10.8809L17.7549 10.7938C17.3519 10.7382 17.031 10.4403 16.8808 10.0622C16.8584 10.006 16.8352 9.95021 16.8109 9.89496C16.6476 9.52216 16.6616 9.08437 16.9058 8.75875L17.1365 8.4512C17.4351 8.05308 17.3955 7.49599 17.0436 7.1441L16.8559 6.95642C16.504 6.60453 15.9469 6.56494 15.5488 6.86353L15.2412 7.09419C14.9156 7.33841 14.4778 7.3524 14.105 7.18905C14.0498 7.16484 13.994 7.14156 13.9378 7.11922C13.5597 6.96897 13.2618 6.64815 13.2062 6.24511L13.1191 5.61336Z"
                                ></path>
                                <path
                                    stroke="currentColor"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="1.5"
                                    d="M13.25 12C13.25 12.6904 12.6904 13.25 12 13.25C11.3096 13.25 10.75 12.6904 10.75 12C10.75 11.3096 11.3096 10.75 12 10.75C12.6904 10.75 13.25 11.3096 13.25 12Z"
                                ></path>
                            </svg>
                        </a>
                    </li>
                </ul>
            </aside>
        </header>
        <table class="flex-1 w-full h-full bg-gray-200">
            <thead>
                <tr class="grid grid-cols-5 gap-px text-right">
                    <th class="px-4 py-2 font-light bg-white">
                        {{ $t('messages.monday_short') }}
                    </th>
                    <th class="px-4 py-2 font-light bg-white">
                        {{ $t('messages.tuesday_short') }}
                    </th>
                    <th class="px-4 py-2 font-light bg-white">
                        {{ $t('messages.wednesday_short') }}
                    </th>
                    <th class="px-4 py-2 font-light bg-white">
                        {{ $t('messages.thursday_short') }}
                    </th>
                    <th class="px-4 py-2 font-light bg-white">
                        {{ $t('messages.friday_short') }}
                    </th>
                </tr>
            </thead>

            <tbody class="grid h-full gap-px" :class="`grid-rows-${calendar.weeks.length}`">
                <tr class="grid grid-cols-5 gap-px" v-for="week in calendar.weeks">
                    <td class="p-4 space-y-2" :class="day.bg_color" v-for="day in week">
                        <p class="font-medium text-right text-gray-500">
                            {{ day.number }}
                        </p>

                        <ul class="-mx-2 space-y-px" v-for="(programming, index) in day.sessions">
                            <span class="text-xs">
                                <inertia-link :href="programming[0].programming_url">
                                    {{ index }}
                                </inertia-link>
                            </span>
                            <li v-for="session in programming">
                                <!--                            <span class="text-xs">{{ session.session.programming_title }}</span>-->
                                <InertiaLink :href="session.session.links.show">
                                    <BadgePill :color="session.group.color">
                                        {{ session.group.name }} -
                                        {{ session.subject }}
                                    </BadgePill>
                                </InertiaLink>
                                <div
                                    v-if="session.session.activities_count === 0"
                                    class="text-xs text-red-400 flex space-x-2"
                                >
                                    <svg
                                        class="w-4 h-4"
                                        fill="currentColor"
                                        viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            fill-rule="evenodd"
                                            d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                                            clip-rule="evenodd"
                                        ></path>
                                    </svg>
                                    <span>
                                        {{ $t('messages.without_activities') }}
                                    </span>
                                </div>
                                <div class="text-xs truncate">
                                    <ul>
                                        <li v-for="activity in session.activities">
                                            <inertia-link :href="activity.url">
                                                {{ activity.title }}
                                            </inertia-link>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </td>
                </tr>
            </tbody>
        </table>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import BadgePill from '@/components/BadgePill.vue';

export default {
    components: {
        PanelPage,
        BadgePill,
    },
    props: ['meta', 'calendar'],
    layout: Layout,
    data() {
        return {};
    },
    name: 'Index',
};
</script>
